export default __webpack_public_path__ + "47bdf0617df19593dd68bd6f7c350c50.png";